function checkIsLocalhost() {
	if (window.location.hostname === 'localhost') {
		return true;
	}

	if (window.location.hostname.match(/192.168.1/)) {
		return true;
	}
	return false;
}

export const isLocalhost = checkIsLocalhost();
